<template>
  <Widget
    title="PROPUESTAS"
    title-link="/page/proposals/list"
    actionLabel="CREAR"
    :indicators="indicators"
    @action="action"
  />
</template>

<script setup>
import {
  ref,
  onMounted,
} from 'vue';
import { useRouter } from 'vue-router';
import useApi from '@/shared/composables/useApi';

import Widget from './base/indicator.vue';

const router = useRouter();

const { apiGet } = useApi();

function action() {
  router.push('/page/proposals/edit');
}

const indicators = ref([]);

const fetchData = async () => {
  const result = await apiGet('/dashboard/propuestas');
  indicators.value = result.data;
};

onMounted(() => {
  fetchData();
});
</script>

<style scoped>
.widget-card {
  margin: 10px;
}

.indicator {
  margin-top: 2rem;
  margin-bottom: 0.5rem;
}

.label {
  font-weight: 600;
}

.value {
  text-align: right;
  /* Alinea el valor a la derecha */
  /* font-size: 1.2em; */
}
</style>
